import { createAppQueryClient, createAppRouter } from '@card-bot/ui-core/app';
import { PlatformProvider, createTelegramPlatform, setPlatform } from '@card-bot/ui-core/platform';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { BRAND } from '@theme/brand.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// styles.css is structural and theme-free; the theme stylesheet loads after
// it so a theme can also override component rules at equal specificity
// (heritage uses this to restore its original geometry and type scale).
import '@card-bot/ui-core/styles.css';
import '@theme/theme.css';

const router = createAppRouter('/miniapp');

// Title, theme-color, and the fonts <link> are stamped into index.html at
// build time from the theme's meta.json (vite.config.ts), so only the
// Telegram WebView chrome needs a runtime call.
const platform = createTelegramPlatform();
setPlatform(platform);
platform.ready(BRAND.chromeColor);

const container = document.getElementById('root');
if (container === null) throw new Error('miniapp-fe: #root element missing');
const root = createRoot(container);
const queryClient = createAppQueryClient();
root.render(
  <StrictMode>
    <PlatformProvider platform={platform}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </PlatformProvider>
  </StrictMode>,
);
